import { atomWithStorage } from 'utils/atomWithStorage';
import { CJPDFSettings } from 'types/cj';
import { useAtomValue, useSetAtom } from 'jotai/react';

export const cjPreviewShareSettingsAtom = atomWithStorage<CJPDFSettings>(
  'cjPreviewShareSettings',
  {
    font: 'roboto',
    size: 14,
    breakinsideavoid: true,
    displaytags: true,
    displaylength: true,
    displaymaterialssum: true,
    displaybilan: true,
    disableClassroomBar: true,
    mainTagColor: 'yellow-200',
    bgColor: 'white',
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 8,
    marginRight: 8,
    displayTeacherName: false,
    displayElevesGroups: false,
  },
);
export const useCjPreviewShareSettings = () =>
  useAtomValue(cjPreviewShareSettingsAtom);

export const useSetCjPreviewShareSettings = () =>
  useSetAtom(cjPreviewShareSettingsAtom);
